import React from 'react';
import clsx from 'clsx';

import styles from './ResultList.module.scss';
import Badge, { BadgeSizes, BadgeStyles } from './Badge';
import Result, { ResultTypes } from './Result';
import Button, { ButtonStyles } from './Button';
import Icon from './Icon';

import { SHOW_RANKED_BUTTON } from '../api/portletConfiguration';

export default function ResultList({
	show,
	searchLabel,
	results,
	onCalcRouteClick,
	onStreetViewClick,
	onDetailClick,
	rankedSorting,
	setRankedSorting,
	rankedSearch,
	focusedResult
}) {
	const DELTA = 10;

	const [currentPage, setCurrentPage] = React.useState(0);

	function handlePageChange(page) {
		setCurrentPage(page);
	}

	const first = currentPage * DELTA;
	const last = first + 10;

	const pagesNumber = results
		? Math.floor(results.length / DELTA) +
		(results.length % DELTA !== 0 ? 1 : 0)
		: null;

	const pageHTML = [];

	for (let i = 0; i < pagesNumber; i++) {
		pageHTML.push(
			<button
				className={clsx(
					styles.paginationControls,
					currentPage === i && styles.current
				)}
				onClick={() => handlePageChange(i)}
				key={i + 1}
			>
				{i + 1}
			</button>
		);
	}

	return show ? (
		<>
			<div>
				<div className={styles.root}>
					<div className={styles.header}>
						{searchLabel}
						<Badge
							text={results ? results.length : null}
							size={BadgeSizes.SMALL}
							variant={BadgeStyles.PRIMARY}
						/>
						{SHOW_RANKED_BUTTON && rankedSearch ? (
							<div className={styles.sortControls}>
								<Button
									className={clsx(
										styles.sortButton,
										rankedSorting ? styles.active : null
									)}
									variant={ButtonStyles.SECONDARY}
									icon={
										<Icon
											icon="icon/suggeriti_blue.png"
											textOn="right"
										/>
									}
									text="Suggerite"
									onClick={() => setRankedSorting(true)}
								/>
								<Button
									className={clsx(
										styles.sortButton,
										!rankedSorting ? styles.active : null
									)}
									variant={ButtonStyles.SECONDARY}
									text="Più vicine"
									onClick={() => setRankedSorting(false)}
								/>
							</div>
						) : null}
					</div>
					<div className={styles.results}>
						{results &&
							results
								.slice(first, last)
								.map((result) => (
									<Result
										key={result.id}
										type={ResultTypes.RESULTS_LIST}
										result={result}
										onCalcRouteClick={onCalcRouteClick}
										onStreetViewClick={onStreetViewClick}
										onDetailClick={onDetailClick}
										highlighted={
											focusedResult ? result.id === focusedResult.id : null
										}
									/>
								))}
					</div>
				</div>
			</div>
			{pagesNumber ? (
				<div className={styles.pagination}>
					<button
						className={clsx(
							styles.paginationControls,
							currentPage === 0 && styles.disabled
						)}
						onClick={
							currentPage === 0
								? null
								: () => handlePageChange(currentPage - 1)
						}
					>
						<strong>&lt;</strong> Precedente
					</button>
					{pageHTML.map((page) => page)}
					<button
						className={clsx(
							styles.paginationControls,
							currentPage === pagesNumber - 1 && styles.disabled
						)}
						onClick={
							currentPage === pagesNumber - 1
								? null
								: () => handlePageChange(currentPage + 1)
						}
					>
						Successiva <strong>&gt;</strong>
					</button>
				</div>
			) : null}
		</>
	) : null;
}
